var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a0df;}.cls-2{fill:#bfebff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back_round"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 301,
    cy: 300,
    r: 300
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.88,257.62l163,133.65a20,20,0,0,0,32.68-15.46V108.51a20,20,0,0,0-32.68-15.46l-163,133.64A20,20,0,0,0,103.88,257.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M504.47,335.27c0,91-90.81,165.09-204,167.62-1.07,0,20.24-8.15,40.81-24.18,2.84-2.22,14.2-11.19,21.5-19.35,18.71-20.91,40.37-69.59,16.26-107.47-16-25.11-47.55-38.35-80.67-36V167.64C411.76,170,504.47,244.15,504.47,335.27Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRound);
export default __webpack_public_path__ + "static/media/back_round.837e99b7e5e0c659a01ae0345b64fa97.svg";
export { ForwardRef as ReactComponent };